import { render, staticRenderFns } from "./InputBetween.vue?vue&type=template&id=3fe97c15&scoped=true&"
import script from "./InputBetween.vue?vue&type=script&lang=js&"
export * from "./InputBetween.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe97c15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VTextField})
